/* eslint-disable import/no-extraneous-dependencies, no-loop-func, no-shadow */
/* global $, playerList, queryString */
import { json } from 'd3-fetch'
import { scaleLinear, scaleOrdinal, scaleLog } from 'd3-scale'
import { schemeCategory10 } from 'd3-scale-chromatic'
import { select, selectAll } from 'd3-selection'
import { extent } from 'd3-array'
import { line } from 'd3-shape'
import { Delaunay } from 'd3-delaunay'
import { axisLeft, axisBottom } from 'd3-axis'
import Table from 'bam-node-savant-table/table'

import uniqBy from 'lodash/uniqBy'
import { guff } from 'bam-node-baseball-savant/utils/guff'

const $loadingMessage = document.getElementById('date-loading-block')
const $errorMessage = document.getElementById('date-error-block')
const $datePicker = document.getElementById('gameDatePicker')

const tableDivId = 'playerTable'

let pitcherData = []
let players = []

const margin = {
    top: 60,
    right: 150,
    bottom: 50,
    left: 60,
}
const color = scaleOrdinal(schemeCategory10)

$(document).ready(() => {
    $('#clearDateButton').click(() => {
        // $('#gameDatePicker').datepicker('setDate', '')
        $datePicker.value = ''
        window.location.href = populateUrl($datePicker.value)
    })
    if (queryString.xAxis) {
        $('#ddlXAxis').val(queryString.xAxis).attr('selected', true)
        $('#lblXAxis').html(`X Axis: ${$('#ddlXAxis option:selected').text()}`)
    }

    createTable(playerList)
    if (queryString.yAxis) {
        $('#ddlYAxis').val(queryString.yAxis).attr('selected', true)
        $('#lblYAxis').html(`Y Axis: ${$('#ddlYAxis option:selected').text()}`)
    }

    if (!queryString.players) {
        loadData('554430') // Wheeler
    } else {
        const qsPlayers = queryString.players.split(',')
        qsPlayers.forEach((player) => {
            loadData(player)
        })
    }
    $('#playerTable, #selectedPitchers').on(
        'click',
        '.default-table-row',
        function handleClick() {
            const id = this.id.split('_')[1]

            if (pitcherData.find((d) => Number(d.player_id) === Number(id))) {
                pitcherData = pitcherData.filter(
                    (d) => Number(d.player_id) !== Number(id)
                )

                players = players.filter(
                    (d) => Number(d[0].player_id) !== Number(id)
                )
                loadSelectedPitchersTable(pitcherData)
                $(`#td_${id}_player_id`).css('color', '#333')
                createChart()
                populateUrl($datePicker.value)
            } else {
                loadData(id)
            }
        }
    )
})

$('#txtPlayerSearch').keyup(() => {
    createTable(filterPlayers())
})

function filterPlayers() {
    return playerList.filter((d) => {
        const playerName = d.player_name_first_last
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
        const searchName = $('#txtPlayerSearch')
            .val()
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
        return playerName.indexOf(searchName) > -1
    })
}

$('.ddl').change(() => {
    $('#lblXAxis').html(`X Axis: ${$('#ddlXAxis option:selected').text()}`)
    $('#lblYAxis').html(`Y Axis: ${$('#ddlYAxis option:selected').text()}`)
    populateUrl($datePicker.value)
    createChart()
})

function loadData(id) {
    $(`#td_${id}_player_id`).css('color', '#3a9098')
    const playerName = $(`#td_${id}_player_id span`).html()

    json(`/savant/api/v1/weighted-score-player?player_id=${id}`).then(
        (data) => {
            if (data && data.length > 0) {
                pitcherData = pitcherData.concat(data)
                players.push(data)
                loadSelectedPitchersTable(pitcherData)
                createChart()
                populateUrl($datePicker.value)
            } else {
                pitcherData = pitcherData.concat([
                    { player_id: id, player_name_first_last: playerName },
                ])
                players.push([
                    { player_id: id, player_name_first_last: playerName },
                ])
            }
        }
    )
}

function refreshData() {
    $loadingMessage.classList.remove('hidden')

    fetch(`/savant/api/v1/weighted-score?date=${$datePicker.value}`)
        .then((res) => res.json())
        .then((data) => {
            $loadingMessage.classList.add('hidden')
            if (!data?.length) {
                $errorMessage.classList.remove('hidden')
                return
            }

            $errorMessage.classList.add('hidden')
            // eslint-disable-next-line no-global-assign
            playerList = data
            createTable(playerList)
        })
}

$datePicker.addEventListener('change', () => {
    refreshData()
})

function loadSelectedPitchersTable(pitchers) {
    $(`#selectedPitchers`).html('')

    const selectedPitchers = uniqBy(pitchers, (d) => d.player_id)

    const headers = [
        {
            name: 'Selected Pitchers',
            field: 'player_name_first_last',
            headerClass: 'th-component-header align-left',
            fieldClass: 'tr-data align-left player',
            id: 'player_id',
        },
    ]

    // eslint-disable-next-line no-new
    new Table({
        id: 'selectedPitchers',
        headers,
        uniqueId: 'player_id',
        defaultSort: 'formatted_game_score',
        defaultSortDirection: 'desc',
        sortClass: 'column-sort',
        // PASS IN UNIQUE ROW ID... Use this for ajax calls
        showRank: false,
        data: selectedPitchers,
    })
}

function createTable(tableData) {
    $(`#${tableDivId}`).html('')
    const headers = [
        {
            name: 'Pitcher',
            field: 'player_name_first_last',
            headerClass: 'th-component-header align-left',
            fieldClass: 'tr-data align-left player',
            id: 'player_id',
        },
        {
            name: $datePicker.value ? 'Rk.' : 'Max<br/>Rank',
            field: 'max_rn',
            type: 'number',
            headerClass: 'th-component-header',
            fieldClass: 'tr-data',
        },
        {
            name: $datePicker.value ? 'Score' : 'Peak<br/>Score',
            field: 'formatted_game_score',
            type: 'number',
            headerClass: 'th-component-header',
            fieldClass: 'tr-data',
            displayFn: (val) => guff(val, 'game_score'),
        },
        {
            name: $datePicker.value ? 'Date' : 'Peak Date',
            field: 'date',
            headerClass: 'th-component-header',
            fieldClass: 'tr-data',
            displayFn: (val) => val.slice(0, 10),
        },
    ]
    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        headers,
        uniqueId: 'player_id',
        defaultSort: $datePicker.value ? 'rn' : 'formatted_game_score',
        defaultSortDirection: 'desc',
        sortClass: 'column-sort',
        // PASS IN UNIQUE ROW ID... Use this for ajax calls
        showRank: false,
        data: tableData,
    })
}

function populateUrl(date) {
    const playerIds = new Set(pitcherData.map((d) => d.player_id))
    const url = `/leaderboard/weighted-score?xAxis=${$(
        '#ddlXAxis'
    ).val()}&yAxis=${$('#ddlYAxis').val()}&players=${[...playerIds].join(
        ','
    )}&date=${date}`
    window.history.pushState('', '', url)
    return url
}

window.addEventListener('resize', () => {
    createChart()
})

function createChart() {
    const xAxis = $('#ddlXAxis').val()
    const yAxis = $('#ddlYAxis').val()

    let pageWidth = $('#weighted_score').width()

    if (!pageWidth) {
        pageWidth = 900
    } else if (pageWidth >= 900) {
        pageWidth -= 400
    }

    const width = 900 - margin.left - margin.right
    const height = 450 - margin.top - margin.bottom

    select('#svg_chart').remove()
    select('#chart').html('')

    const svg = select('#chart')
        .append('svg')
        .attr('id', 'svg_chart')
        .attr(
            'viewBox',
            `0 0 ${width + margin.left + margin.right} ${
                height + margin.top + margin.bottom
            }`
        )
        .attr('width', pageWidth)
        .attr('height', pageWidth / 2)

    const title = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top / 3})`)

    title
        .append('text')
        .attr('x', width / 2)
        .attr('text-anchor', 'middle')
        .text('Weighted Game Score')

    const graph = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)

    const legend = svg
        .append('g')
        .attr('transform', `translate(${margin.left + width},${margin.top})`)

    const xExt = extent(pitcherData, (d) => Number(d[xAxis]))
    const yExt = extent(pitcherData, (d) => Number(d[yAxis]))

    const x = scaleLinear().range([0, width]).domain(xExt)
    let y

    if (yAxis === 'formatted_game_score') {
        y = scaleLinear().range([height, 0]).domain([25, 70])
    } else {
        y = scaleLog().range([height, 0]).domain(yExt.reverse())
    }

    const l = line()
        .x((d) => x(d[xAxis])) // .y(d=>y(d.rn))
        .y((d) => y(d[yAxis]))

    const yAxisLegend = axisLeft(y).tickFormat((d) => {
        // remove certain log scale values
        const val = Number(d)
        if (
            yAxis === 'rn' &&
            (val === 6 ||
                val === 7 ||
                val === 8 ||
                val === 9 ||
                val === 60 ||
                val === 70 ||
                val === 80 ||
                val === 90)
        ) {
            return ''
        }
        return Number(d)
    })
    const xAxisLegend = axisBottom(x).tickFormat((d) => Number(d))

    // Append Y Axis
    graph
        .append('g')
        .attr('class', `y axis type_${yAxis}`)
        .call(yAxisLegend)
        .call((g) => {
            if (yAxis === 'rn') {
                g.selectAll('.tick line').remove()
            }
        })
    graph
        .append('g')
        // .attr("class", `type_${yAxis}`)
        .append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 0 - margin.left)
        .attr('x', 0 - height / 2)
        .attr('dy', '1em')
        .style('text-anchor', 'middle')
        .text($('#ddlYAxis option:selected').text().replace('Y Axis:', ''))

    // Append X Axis
    graph
        .append('text')
        .attr(
            'transform',
            `translate(${width / 2} ,${height + margin.bottom / 1.25})`
        )
        .style('text-anchor', 'middle')
        .text($('#ddlXAxis option:selected').text().replace('X Axis:', ''))

    graph
        .append('g')
        .attr('transform', `translate(0,${height})`)
        .attr('class', 'x axis')
        .call(xAxisLegend)

    const playerNames = []

    if (yAxis === 'formatted_game_score') {
        graph
            .append('line')
            .attr('x1', x(xExt[0]))
            .attr('y1', y(50))
            .attr('x2', x(xExt[1]))
            .attr('y2', y(50))
            .attr('stroke', '#c2c2c2')
            .attr('stroke-dasharray', '4')

        graph
            .append('text')
            .attr('y', y(48.5))
            .attr('x', x(xExt[1]))
            .attr('text-anchor', 'end')
            .attr('fill', '#c2c2c2')
            .style('font-size', '.7rem')
            .text('AVG')
    }

    graph
        .selectAll('graph')
        .data(players)
        .join('path')
        .attr('d', (d) => l(d))
        .attr('class', 'graph-line')
        .attr('id', (d) => `graph_${d[0].player_id}`)
        .attr('fill', 'none')
        .attr('stroke', (d, i) => {
            playerNames.push({
                name: d[0].player_name_first_last,
                color: color(i),
                id: d[0].player_id,
            })

            return color(i)
        })
        .attr('stroke-width', 2)

    if ($datePicker.value) {
        const selectedDate = pitcherData.filter(
            (d) => d.target_date_formatted === $datePicker.value
        )

        graph
            .selectAll('dots')
            .data(selectedDate)
            .enter()
            .append('circle')
            .attr('cx', (d) => x(d[xAxis]))
            .attr('cy', (d) => y(d[yAxis]))
            .attr('r', 3)
            .attr('fill', '#f00')
            .attr('stroke', '#000')
    }

    legend
        .selectAll('players')
        .data(playerNames)
        .join('text')
        .attr('x', 20)
        .attr('y', (d, i) => 25 + i * 25)
        .attr('fill', (d) => d.color)
        .text((d) => d.name)
        .on('mouseover', (data) => {
            selectAll('.graph-line').classed('graph-mono', true)
            select(`#graph_${data.id}`).classed('graph-mono', false)
        })
        .on('mouseout', () => {
            selectAll(`.graph-line`).classed('graph-mono', false)
        })

    const voronoi = Delaunay.from(
        pitcherData,
        (d) => x(d[xAxis]),
        (d) => y(d[yAxis])
    ).voronoi([0, 0, width, height])

    const tooltip = (g) => {
        const tooltip = g.append('g').style('font', '10px sans-serif')

        const path = tooltip.append('path').attr('fill', 'white')

        const text = tooltip.append('text')

        const line1 = text
            .append('tspan')
            .attr('x', 0)
            .attr('y', 0)
            .style('font-weight', 'bold')

        const line2 = text.append('tspan').attr('x', 0).attr('y', '1.1em')

        const line3 = text.append('tspan').attr('x', 0).attr('y', '2.2em')

        g.append('g')
            .attr('fill', 'none')
            .attr('pointer-events', 'all')
            .selectAll('path')
            .data(pitcherData)
            .join('path')
            //   .attr("stroke","#000")
            //   .attr("opacity",.25)
            .attr('d', (d, i) => voronoi.renderCell(i))
            .on('mouseout', () => {
                tooltip.style('display', 'none')
                selectAll('.graph-line').classed('graph-mono', false)
            })
            .on('mouseover', (d) => {
                selectAll('.graph-line').classed('graph-mono', true)
                selectAll(`#graph_${d.player_id}`).classed('graph-mono', false)
                tooltip.style('display', null)
                line1.text(`${d.player_name_first_last}`)
                line2.text(`${d.target_date_formatted}`)
                const yAxisType =
                    yAxis === 'rn' ? `League Ranking` : `Game Score`
                const precision = yAxis === 'rn' ? 0 : 1
                const yAxisVal = Number(d[yAxis]).toFixed(precision)
                line3.text(`${yAxisType}: ${yAxisVal}`)
                path.attr('stroke', '#000')
                const box = text.node().getBBox()
                path.attr(
                    'd',
                    `
                M${box.x - 10},${box.y - 10}
                H${box.width / 2 - 5}l5,-5l5,5
                H${box.width + 10}
                v${box.height + 20}
                h-${box.width + 20}
                z
              `
                )
                tooltip.attr(
                    'transform',
                    `translate(${x(d[xAxis]) - box.width / 2},${
                        y(d[yAxis]) + 28
                    })`
                )
            })
    }

    svg.append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)
        .call(tooltip)
}
